import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddChapterpage = () => {
  const [formValues, setFormValues] = useState({
    position: "",
    department_id: "",
    courseCategory_id: "",
    course_id: "",
    chaptername: "",
  });

  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [course, setCourse] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchdepartment = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setDepartments(response.data.data);
        // console.log(response.data.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchdepartment();
  }, []);

  useEffect(() => {
    if (formValues.course_id) {
      const fetchChaptertLatestPosition = async () => {
        // setLoading(true);
        try {
          const token = localStorage.getItem("token");
          if (token) {
            const response = await axios.get(
              `${process.env.REACT_APP_INSTITUTION_BASEURL}/chapters/getposition/${formValues.course_id}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            const data = response.data.data || 1;
            // setLatestPosition(data.largestPosition + 1 || 1);
            setFormValues({
              ...formValues,
              position: data.largestPosition + 1 || 1,
            })
          }
        } catch (err) {
          setError("Failed to fetch grade.");
        } finally {
          setLoading(false);
        }
      };

      fetchChaptertLatestPosition();
    } else {
      setFormValues({ ...formValues, position: 0 });
    }
  }, [formValues.course_id]);

  useEffect(() => {
    const fetchCourseCategory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${formValues.department_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourseCategories(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourseCategory();
  }, [formValues.department_id]);
  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses/${formValues.department_id}/${formValues.courseCategory_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourse(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourse();
  }, [formValues.courseCategory_id, formValues.department_id]);

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (isSaving) return; // Prevent multiple submissions
    
    try {
      setIsSaving(true);
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-chapter`,
        formValues,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 201) {
        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/chapter-list");
        }, 2000);
      }
    } catch (err) {
      setIsSaving(true);
      setLoading(true);

      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to create. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } 
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={handleFormSubmit}>
              <div className="mb-20">
                <label
                  htmlFor="depart"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="depart"
                  value={formValues.department_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      courseCategory_id: "",
                      course_id: "",
                      department_id: e.target.value,
                    })
                  }
                  required
                >
                  <option value="" disabled>
                    Select a Department
                  </option>
                  {departments.map((department) => (
                    <option key={department._id} value={department._id}>
                      {department.department_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-20">
                <label
                  htmlFor="courseCategory"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Level
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="courseCategory"
                  value={formValues.courseCategory_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      course_id: "",
                      courseCategory_id: e.target.value,
                    })
                  }
                  required
                >
                  <option value="" disabled>
                    Select a Level
                  </option>
                  {courseCategories.map((courseCategory) => (
                    <option key={courseCategory._id} value={courseCategory._id}>
                      {courseCategory.courseCategoryName}
                    </option>
                  ))}
                </select>
              </div>
              {/* courseid */}
              <div className="mb-20">
                <label
                  htmlFor="courseCategory"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Course
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="courseCategory"
                  value={formValues.course_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      course_id: e.target.value,
                    })
                  }
                  required
                >
                  <option value="" disabled>
                    Select a course
                  </option>
                  {course.map((courses) => (
                    <option key={courses._id} value={courses._id}>
                      {courses.coursename}
                    </option>
                  ))}
                </select>
              </div>

              {/* Chapter Name */}
              <div className="mb-20">
                <label
                  htmlFor="chaptername"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Chapter Position
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  id="chapterposition"
                  placeholder="Enter chapter position"
                  className="form-control radius-8"
                  value={formValues.position}
                  onChange={(e) =>
                    {
                      const value = e.target.value;
                      if (value === "" || value.trim() !== "") {
                    setFormValues({
                      ...formValues,
                      position: e.target.value,
                    });
                  }}}
                  required
                />
              </div>
              {/* Chapter Name */}
              <div className="mb-20">
                <label
                  htmlFor="chaptername"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Chapter Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  id="chaptername"
                  placeholder="Enter chapter name"
                  className="form-control radius-8"
                  value={formValues.chaptername}
                  onChange={(e) =>
                    {
                      const value = e.target.value;
                      if (value === "" || value.trim() !== "") {
                    setFormValues({
                      ...formValues,
                      chaptername: e.target.value,
                    });
                  }}}
                  required
                />
              </div>

              {/* Fees */}
              {/* <div className="mb-20">
                    <label
                      htmlFor="fees"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Fees
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="fees"
                      className="form-control radius-8"
                      value={formValues.fees}
                      onChange={(e) =>
                        setFormValues({ ...formValues, fees: e.target.value })
                      }
                      required
                    />
                  </div> */}

              {/* Brief */}
              {/* <div className="mb-20">
                    <label
                      htmlFor="brief"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Brief
                      <span className="text-danger-600">*</span>
                    </label>
                    <textarea
                      id="brief"
                      className="form-control radius-8"
                      value={formValues.brief}
                      onChange={(e) =>
                        setFormValues({ ...formValues, brief: e.target.value })
                      }
                      required
                    />
                  </div> */}

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/chapter-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  disabled={isSaving || loading} // Ensure button is disabled
                >
                  {loading && "Save"}
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  {!loading && "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddChapterpage;
